import { render, staticRenderFns } from "./QuestionEntityDetails.vue?vue&type=template&id=32963219&scoped=true"
import script from "./QuestionEntityDetails.vue?vue&type=script&lang=js"
export * from "./QuestionEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./QuestionEntityDetails.vue?vue&type=style&index=0&id=32963219&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32963219",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32963219')) {
      api.createRecord('32963219', component.options)
    } else {
      api.reload('32963219', component.options)
    }
    module.hot.accept("./QuestionEntityDetails.vue?vue&type=template&id=32963219&scoped=true", function () {
      api.rerender('32963219', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuestionEntityDetails.vue"
export default component.exports